// extracted by mini-css-extract-plugin
export var description = "structure-module--description--e15ca";
export var hero = "structure-module--hero--a569b";
export var member = "structure-module--member--a9a27";
export var members = "structure-module--members--177cd";
export var root = "structure-module--root--ff717";
export var row = "structure-module--row--eb3fc";
export var title = "structure-module--title--47b19";